import type { FaireProductEntity } from "../../entity_types/product";

export const defaultProduct: FaireProductEntity = {
  token: "default",
  type: "product",
  brandName: "Default Brand",
  categoryTokens: [],
  description: "Default product entity",
  imageUrl: "",
  name: "Default Product",
  priceDollars: 0,
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
